"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Maaji = function Maaji(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 272.13 119.42",
    width: "272.13",
    height: "119.42"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M271,59c-3.51,0-5.14,14.14-13.58,14.14-4.68,0-6.51-5.06-1.29-19.37,5.49-15.18,8.13-22.34,8.16-22.41s1.14-3.39-2.09-4.53a3.48,3.48,0,0,0-4.48,2C248.14,53.12,233.53,67,219.65,77c7.09-19.42,16.54-45.28,16.67-45.65h0c.08-.23.93-3.34-1.86-4.4a3.53,3.53,0,0,0-4.77,2c-.17.48-2.59,6.22-3.83,9C220,51.14,208.86,71.38,199,71.38c-2.26,0-2.26-4.72,2.46-17.65l8.25-22.68a3.53,3.53,0,0,0-2.4-4.64,3.61,3.61,0,0,0-4.26,2.31l-.91,2.41s-2.38-4.78-9.17-4.78c-12.8,0-26,14-31.32,28.85-3.18,8.91-10.33,16.29-14.35,16.29-3.3,0-3.06-4.89,1.63-17.73l8.28-22.71a3.53,3.53,0,0,0-2.39-4.64,3.63,3.63,0,0,0-4.27,2.31l-.9,2.41s-2.35-4.78-9.17-4.78c-13.57,0-24.86,14.32-30.28,25.87C105.8,61.68,102,67.91,98.35,67.91c-11.69,0,5.17-51.76,12.36-59.28,2.19-2.29,4.2-.16,5.47-1.6,1.95-2.23-1-7-8.23-7-14.7,0-24.84,18.2-31.2,30.61C63,57.53,59.11,66.44,55.44,66.44c-3.37,0-3.07-16.92,5.18-38.5,5-13.09,7.32-16.66,8.57-18.18,3-3.7,5.29-1.31,6.43-2.73,1.87-2.33-1-7-8.47-7C50.79,0,39.82,22.53,30,42.52,22.24,58.37,13.57,76.05,4.9,76.05c-1.8,0-3.7-.67-4.48.39-1.51,2,1.21,5.38,6.2,5.38,22.26,0,34-63.22,55.11-73.59a.6.6,0,0,1,.82.83C53.18,23.6,43.47,47.83,41.4,63.48c-.26,2-2.24,18.34,8.17,18.34,18.85,0,32.16-62,52.77-73.59a.61.61,0,0,1,.84.83C93.89,23,67.66,81.82,91.69,81.82c5.71,0,12.53-4.19,16.7-10.1.48,2.22,3.19,10.1,12,10.1,5.12,0,11-3.73,16.07-8.55.13,1.77.77,8.55,8.72,8.55,4.38,0,10.19-3.64,15.55-10.72.48,2.17,2.9,10.72,12.16,10.72,5.11,0,11-3.73,16-8.53.13,1.76.62,8.53,8.71,8.53,5,0,10.71-4,17.06-11.87-1.8,4.92-3.33,9.15-5,13.76-5.64,3.56-14.24,8.17-19.11,12.58-5.71,5.17-8.88,11.32-6.75,16.9a9.65,9.65,0,0,0,9.42,6.23c9.68,0,15.11-11.51,18.76-21.55l3.48-9.52c8.12-5.22,19.38-13,29.46-24.18-2.08,8-.14,17.91,9.78,17.91C270.13,82.08,274.5,59,271,59ZM122.47,71.4c-3.72,0-8.12-4.9-3.51-17.67,4-10.95,12.22-19,19.93-20.18s8.39,4,7.32,6.86l-4.09,10.9C137.73,63.35,130.16,71.4,122.47,71.4Zm53.07,0c-7.08,0-7.17-9.47-4.09-17.67,4.15-11,11.36-18.47,20.05-20.19,3.39-.68,9.48.79,7.17,7-1.23,3.29-3.41,9-4.29,11.45C189.92,63.65,182.33,71.4,175.54,71.4Zm29.35,26.3c-3.68,7.42-7.45,13.12-10.6,10.82-3.5-2.56,1.92-7.56,6.54-11.34,2.55-2,3.88-2.75,6.53-4.53C206.93,93.73,205.72,96,204.89,97.7Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M237.81,18.93a4.35,4.35,0,1,0-4.34-4.35A4.35,4.35,0,0,0,237.81,18.93Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M266.05,18.93a4.35,4.35,0,1,0-4.34-4.35A4.35,4.35,0,0,0,266.05,18.93Z"
  })));
};
Maaji.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Maaji.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Maaji;